import { Injectable } from '@angular/core';

import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
  ICustomerIdentBean,
  ISaasResidentLandlordCustomerResponse,
  IUserSaasResidentAppsResponse,
} from '../../../models';
import { customerIdentQuery, getUserRegisteredSaasResidentAppsQuery } from '../../../queries';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class UserAppsFacade {
  constructor(private apollo: Apollo) {}

  public getUserRegisteredSaasResidentApps(): Observable<ISaasResidentLandlordCustomerResponse[]> {
    return this.apollo
      .query<{
        getUserRegisteredSaasResidentApps: IUserSaasResidentAppsResponse;
      }>({
        query: getUserRegisteredSaasResidentAppsQuery,
      })
      .pipe(
        map(response => {
          if (response?.data?.getUserRegisteredSaasResidentApps?.registeredApps) {
            return response.data.getUserRegisteredSaasResidentApps.registeredApps;
          }
          // Apollo Client v4 emits errors via the error channel; reaching here means missing data
          throw new Error('Registered apps response missing');
        }),
        catchError((error: Error) => {
          console.error(error);
          throw new Error(error.message);
        })
      );
  }

  public getCustomerIdent(domain: string): Observable<ICustomerIdentBean> {
    return this.apollo
      .query<{ getCustomerIdent: ICustomerIdentBean }>({
        query: customerIdentQuery,
        context: {
          headers: new HttpHeaders({
            'x-web-portal-domain': domain,
          }),
        },
      })
      .pipe(
        map(response => {
          if (response?.data?.getCustomerIdent?.customerIdent) {
            return response?.data?.getCustomerIdent;
          }

          throw new Error('customerIdent is missing');
        }),
        catchError((error: Error) => {
          throw new Error(error.message);
        })
      );
  }
}
